import { render, staticRenderFns } from "./FontYear.vue?vue&type=template&id=ad85de58&"
import script from "./FontYear.vue?vue&type=script&lang=js&"
export * from "./FontYear.vue?vue&type=script&lang=js&"
import style0 from "./FontYear.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports